import api from '../commonJs/http.js'
import store from '../store/index.js'

const _import = require('@/router/_import_' + process.env.NODE_ENV)

function LoadMenu(router, routes, childrenIndex, to, next, NProgress) {
  //判断菜单数据
  if ((!(store.state.menuData && store.state.menuData.length > 0)) && to.path != '/Error' && to.path != '/NoAuth') {
    api.get(
      _myconfig.menuUrl,
      null,
      function (data) {
        if (data.code == 200) {
          store.commit("saveMenuData", data.data);

          //设置首页重定向,这里将获取的菜单pid=0中第一项的不为#的url作为首页
          //这里没有直接在代码中设置main重定向，原因是菜单中配置url时可能会设置些url参数
          let indexModual = data.data.filter(function (m) {
            return m.ParentID == "0";
          });
          if (indexModual[0].Url != undefined && indexModual[0].Url != null && indexModual[0].Url != '#' && indexModual[0].Url != '') {
            let redirect = CreateIndexRedirect(indexModual[0]);

            let queryArr = Object.keys(to.query);
            for (let i = 0; i < queryArr.length; i++) {
              const item = queryArr[i];
              redirect.query[item] = to.query[item];
            }
            routes[childrenIndex].redirect = redirect;
            //设置菜单首页选中
            if (!window.sessionStorage.getItem('curMenu')) {
              store.commit('setCurMenu', indexModual[0].Url);
            }

          }
          else {
            let indexPage = data.data.filter(function (m) {
              return m.ParentID == indexModual[0].ID;
            });
            let redirect = CreateIndexRedirect(indexPage[0]);
            let queryArr = Object.keys(to.query);
            for (let i = 0; i < queryArr.length; i++) {
              const item = queryArr[i];
              redirect.query[item] = to.query[item];
            }
            routes[childrenIndex].redirect = redirect;
            //设置菜单首页选中
            if (!window.sessionStorage.getItem('curMenu')) {
              store.commit('setCurMenu', indexPage[0].Url);
            }

          }
          try {
            router.addRoutes(routes);
          } catch (error) {
            console.log(error);
          }
          next({ ...to, replace: true });//replace属性为true的时候可以让链接在跳转的时候不会留下历史记录
        } else if (data.code == 401 || data.code == 410) {
          router.addRoutes(routes);
          RedirectLogin();
        }
        else {
          router.addRoutes(routes);
          next({ path: '/Error' });
        }
        NProgress.done();
      },
      function () {
        NProgress.done();
        router.addRoutes(routes);
        next({ path: '/Error' });
      }
    );
  }
  else {
    // store.commit('setCurMenu',);
    if (to.path.startsWith("/Layout") && to.query["Src"]) {
      //保存Src到store中，去除url中的Src,
      store.commit("saveIframeLayoutSrc", to.query["Src"]);
      let queryParam = {};
      for (var p in to.query) {
        if (p != "Src") {
          queryParam[p] = to.query[p];
        }
      }
      next({ path: to.path, query: queryParam });
    }
    else {
      NProgress.done();
      next();
    }

  }
}
function CreateIndexRedirect(item) {

  let redirect = { path: '', query: {} };
  let urlArr = item.Url.split('?');
  redirect.path = urlArr[0];
  if (urlArr.length == 2) {
    let paramArr = urlArr[1].split('&');
    for (let i = 0; i < paramArr.length; i++) {
      let element = paramArr[i];
      redirect.query[element.split('=')[0]] = element.split('=')[1]
    }
  }
  return redirect;
}
function RedirectLogin() {
  let to = window.location.href;
  let loginUrl = _myconfig.loginUrl + "SSO/Login?RedirectUrl=" + encodeURIComponent(to) + "&sysid=" + _myconfig.sysid;
  //let loginUrl = _myconfig.loginUrl + "SSO/Login?RedirectUrl=111&sysid=" + _myconfig.sysid;
  window.location.href = loginUrl;
}

export default {
  LoadMenu: function (router, routes, childrenIndex, to, next, NProgress) {
    return LoadMenu(router, routes, childrenIndex, to, next, NProgress);
  }
}